export default {
  findRouteByQuote: {
    method: 'post',
    url: '/partner/order/route/find-by-quote'
  },
  findRouteByQuoteRequestData: {
    method: 'post',
    url: '/partner/order/route/find-by-data-quote-request'
  }
}
